import React from 'react';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import DivContainer from '../components/DivContainer';
import {ActionButton} from '../components/ActionButton';
import CardUserService from '../services/CardUserService';
import CardService from '../services/CardService';
class CardChangeBlockedDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardUserService());
        this.cardService = new CardService();
        this.state = {
            viewMode: this.props.viewMode,
        };
        this.renderFooter = this.renderFooter.bind(this);
        this.renderSaveLabel = this.renderSaveLabel.bind(this);
    }
    getContainerListName() {
        return 'user-card-list-container';
    }
    renderSaveLabel() {
        const {t} = this.props;
        return this.props.blockCard ? t('cards.cardBlockHeader') : t('cards.cardUnblockHeader');
    }
    renderFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => this.props.onHide(undefined)}
                />
                <ActionButton label={this.renderSaveLabel()} variant='button save-button fullred' handleClick={this.handleFormSubmit} />
            </div>
        );
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='col-12 change-blocked-dialog-header'>
                    <DivContainer colClass='col-12'>
                        <label id={`change-blocked-dialog-header-label-id`}>
                            {`${t(`cards.${this.props.blockCard ? 'cardBlockHeader' : 'cardUnblockHeader'}`)}: ${
                                this.props.cardNumber
                            }`}
                        </label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }
    setElement() {
        this.initAfterSetElement();
    }
    createOrUpdate() {
        const {cardNumber, t} = this.props;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (this.props.blockCard) {
                this.cardService
                    .blockCard(cardNumber)
                    .then((response) => {
                        this.blockUi();
                        if (this.props.afterSave) {
                            this.persistMessage('success', '', t('cards.successBlockCard'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleSuccess) {
                            this.unblockUi();
                            this.props.handleSuccess(response);
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.persistMessage('error', '', t('error.errorBlockCard'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleError) {
                            this.unblockUi();
                            this.props.handleError();
                        }
                    });
            } else {
                this.cardService
                    .unblockCard(cardNumber)
                    .then((response) => {
                        this.blockUi();
                        if (this.props.afterSave) {
                            this.persistMessage('success', '', t('cards.successUnblockCard'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleSuccess) {
                            this.unblockUi();
                            this.props.handleSuccess(response);
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.persistMessage('error', '', t('error.errorUnblockCard'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleError) {
                            this.unblockUi();
                            this.props.handleError();
                        }
                    });
            }
        }
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <div className='change-blocked-container'>
                <DivContainer colClass='back-off-row'>
                    <div className='change-blocked-label'>{t(`cards.${this.props.blockCard ? 'cardBlockDesc' : 'cardUnblockDesc'}`)}</div>
                </DivContainer>
            </div>
        );
    }
}

CardChangeBlockedDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    cardNumber: '',
    blockCard: false,
};

CardChangeBlockedDialog.propTypes = {
    currentUser: PropTypes.object,
    viewMode: PropTypes.string,
    onHide: PropTypes.func,
    visible: PropTypes.bool,
    afterSave: PropTypes.func,
    cardNumber: PropTypes.string,
    blockCard: PropTypes.bool,
};

export default withTranslation()(CardChangeBlockedDialog);
